export const maxNoTouchSeats = 50;
export const CARD_CLASS = "card";
export const DEFAULT_CONTACT_SALES_LINK = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
export const THANK_YOU_PAGE = "/contact-sales-thank-you";
export const THANK_YOU_PAGE_SB = "/contact-sales-thank-you-sb";
export const HS_FROM_FIELD_VALUE = "pricing";
